import { useState, useEffect } from "react";
import useDebounce from "./useDebounce";
export default (value, setValue, timeout = 500) => {
    const [valueState, setValueState] = useState(value);
    const debouncedValue = useDebounce(valueState, timeout);
    useEffect(() => {
        if (value !== debouncedValue)
            setValue(debouncedValue);
    }, [debouncedValue]);
    useEffect(() => {
        if (value !== valueState)
            setValueState(value);
    }, [value]);
    return [valueState, setValueState];
};
//# sourceMappingURL=useDebouncedState.js.map